import {
  IonCard,
  IonLabel,
  IonTitle,
  IonCardHeader,
  IonCardContent,
} from "@ionic/react";
import moment from "moment";
import { useEffect, useState } from "react";

import "./styles.css";

import { BreedingAttempt } from "../../../../models/breeding";
import useSiresService from "../../../../services/useSiresService";
import { Sire } from "../../../../models";

interface BreedingRecordCardProps {
  breedingRecord: BreedingAttempt;
}
export default function BreedingRecordCard({
  breedingRecord,
}: BreedingRecordCardProps): React.ReactElement {
  const { getSire } = useSiresService();
  const [sire, setSire] = useState<Sire>();

  useEffect(() => {
    fetchSire();

    async function fetchSire() {
      const sire = await getSire(breedingRecord.sireId);
      setSire(sire);
    }
  }, [getSire, breedingRecord.sireId]);

  return (
    <IonCard
      routerLink={`/cows/${breedingRecord.cowId}/breedings/${breedingRecord.id}`}
    >
      <div style={{ marginBlock: 10, textAlign: "left" }}>
        <IonCardHeader>
          <IonTitle>{`${moment(
            breedingRecord.createdAt?.toDate()
          ).year()} Record`}</IonTitle>
        </IonCardHeader>
      </div>
      <IonCardContent>
        <IonLabel>
          {/* Sire ID: <span>{breedingRecord?.sireId || ""}</span> */}
          Sire ID: <span>{sire?.sireName || ""}</span>
        </IonLabel>
        <IonLabel>
          Attempt Date: <span>{breedingRecord.attemptDate}</span>
        </IonLabel>
        <IonLabel>
          Ai Tech: <span>{breedingRecord.aiTech}</span>
        </IonLabel>
      </IonCardContent>
    </IonCard>
  );
}
